import BaseHttpService from "../baseService";

class TicketServiceProvider extends BaseHttpService {
	constructor() {
		super("my-ticket");
	}

	/**
	 * Add ticket
	 *
	 * @async
	 * @version 1.0.0
	 */
	public addTicket(data: TicketInput): HttpService.BaseResponse {
		return this.getResource().post("add-new-ticket", data);
	}

	close(id: TicketInput) {
		return this.getResource().get(`close-ticket/${id}`);
	}

	loadMsg(id: string) {
		return this.getResource().get(`load-msg/${id}`);
	}

	sendMsg(data: any) {
		return this.getResource().post("add-new-msg", data);
	}
}

export type TicketInput = {
	category: string;
	id: string;
	msg: string;
	title: string;
};

export enum TicketStatus {
	NEW = "NEW",
	CLOSED = "CLOSED",
	OPERATOR_REPLY = "OPERATOR_REPLY",
	IN_PROGRESS = "IN_PROGRESS",
	USER_REPLY = "USER_REPLY",
}

export type TicketModel = {
	createdDate: number;
	id: string;
	lastModifiedDate: number;
	status: TicketStatus;
	title: string;
	user: object;
	category: string;
};

const TicketService = new TicketServiceProvider();

export default TicketService;
